module.exports = __webpack_public_path__ + "static/assets/c6b4de3142c5b93236828db338bfbfdd.svg";